<template>
   <v-container fluid>
      <v-row class="px-0 py-0" align="center" justify="center">
         <v-card flat>
            <v-card-text>
               <div v-html="exitMessage"></div>
            </v-card-text>
         </v-card>
      </v-row>

      <v-row class="px-0 py-0" align="center" justify="center">
         <v-img src="@/assets/signout-bg.jpeg"> </v-img>
      </v-row>
   </v-container>
</template>

<script>
   export default {
      data() {
         return {
            exitMessage: "Thank you for using the CCA Portal. Please close this tab to exit.",
         };
      },
   };
</script>
